export const reportConversion = () => {
  try {
    const callback = function () {
      console.log('Conversion reported');
    };
    (window as any).gtag('event', 'conversion', {
      'send_to': 'AW-351319251/0LVrCJKDo7EDENPpwqcB',
      'event_callback': callback
    });
    return false;
  } catch(e) {
    console.error(e);
  }
}